define([
	"csi/def",
	"csi/def/ActionFactory",
	"csi/image/_base",
	"./ActionImage"
], function(def,ActionFactory,image,ActionImage) {

	return ActionFactory.declare("imageLeft", ActionImage, {
		constructor: function(xml) {
			this.m_id = "PropertyImageLeft";
			this.m_class = "iconImageLeft";
			this.m_typeControl = def.ACTION_ICON;
		},

		hasAccess: function(/*def.Context*/ctx) {
			// summary: determine if selected image can move left
			var	key = ctx.view.getCurrentImageKey();
			var	keyFirst = image.getFirstKey(this.getImageValue(ctx.getNode()));
			return key && (key != keyFirst) && this.inherited(arguments);
		}
	});
});